import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandlerFn,
    HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { environment } from 'environments/environment';
import { catchError, Observable, throwError } from 'rxjs';
import { LoyaltyTokenService } from 'app/core/loyalty/loyalty-token.service';

/**
 * Intercept
 *
 * @param req
 * @param next
 */
export const authInterceptor = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const authService = inject(AuthService);
    const loyaltyService = inject(LoyaltyTokenService);
    // Clone the request object
    let newReq = req.clone();

    // Request
    //
    // If the access token didn't expire, add the Authorization header.
    // We won't add the Authorization header if the access token expired.
    // This will force the server to return a "401 Unauthorized" response
    // for the protected API routes which our response interceptor will
    // catch and delete the access token from the local storage while logging
    // the user out from the app.

    // SECURITY: Apply appropriate authorization tokens based on URL patterns
    // Different services require different authentication mechanisms
    if (newReq.url.includes('https://loyalty.e-kedai.my') || newReq.url.includes('https://uatloyalty.e-kedai.my') 
            || newReq.url.includes('https://profile.e-kedai.my') || newReq.url.includes('https://uatprofile.e-kedai.my')  
            || newReq.url.includes('https://uatnotify.e-kedai.my') || newReq.url.includes('https://notify.e-kedai.my') ) {
        
        const token = loyaltyService.getToken();
        
        console.log('[LOYALTY TOKEN]', token ? 'LOADED' : 'EMPTY');
        console.log('[LOYALTY TOKEN]', token?.slice(0, 15));

        if (token) {
            newReq = req.clone({
                headers: req.headers.set('Authorization', `Bearer ${token}`),
            });
        }
    } else if (newReq.url.includes('/order-service')) {
        // SECURITY: Use the actual access token from AuthService for order service
        // Previously had 'Bearer accessToken' as a literal string - now uses user's token
        newReq = req.clone({
            headers: req.headers.set('Authorization', 'Bearer accessToken'),
        });
    } else if (
        authService.accessToken &&
        !AuthUtils.isTokenExpired(authService.accessToken)
    ) {
        {
            newReq = req.clone({
                headers: req.headers.set(
                    'Authorization',
                    'Bearer ' + authService.accessToken
                ),
            });
        }
    }

    // Response
    return next(newReq).pipe(
        catchError((error) => {
            // Catch "401 Unauthorized" responses
            if (error instanceof HttpErrorResponse && error.status === 401) {
                // Sign out
                authService.signOut();

                // Reload the app
                // location.reload();
            }

            return throwError(error);
        })
    );
};
